import StateOfTheSectorComponent from 'components/marketingSite/stateOfTheSector/StateOfTheSectorComponent';
import HeadMetadata from 'components/shared/HeadMetadata';
import { useI18n } from 'hooks/useI18n';
import { usePageTrack } from 'hooks/usePageTrack';
import { GetStaticProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { APP_URLS } from 'utils/app-urls';
import { config } from 'utils/config';
import { getPublicPath } from 'utils/paths';

type StateOfTheSectorPageProps = {
  baseUrl?: string;
};

const StateOfTheSectorPage: React.FC<StateOfTheSectorPageProps> = ({
  baseUrl
}) => {
  const { t } = useI18n('state-of-the-sector');

  usePageTrack('Landing - Page Loaded');

  return (
    <>
      <HeadMetadata
        title={t('page_title')}
        url={APP_URLS.mandecar22}
        desc={t('page_description')}
        imgUrl={`${baseUrl}${getPublicPath(
          '/images/cards/card_state_of_the_sector.png'
        )}`}
      />
      <StateOfTheSectorComponent />
    </>
  );
};

export default StateOfTheSectorPage;

export const getStaticProps: GetStaticProps<
  StateOfTheSectorPageProps
> = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale || '', [
        'common',
        'topbar',
        'footer',
        'state-of-the-sector'
      ])),
      baseUrl: config.appUrl
    },
    revalidate: 30
  };
};
